module.exports = __webpack_public_path__ + "img/yj_wx_to_see.ee1372fa.png";